var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_vm._m(0),_c('com-mpage',{attrs:{"list":_vm.list,"idx":_vm.idx},on:{"changv":_vm.changeValue}}),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-banner"},[_c('h1',[_vm._v("About Us")]),_c('span',[_vm._v("关于我们")])])
}]

export { render, staticRenderFns }